export default __webpack_public_path__ + "static/media/man-supervillain_1f9b9-200d-2642-fe0f.825fc001.png";